export enum OrganizationType {
  Main = 1,
  JointNominee = 2,
}
